<!--<app-layout *ngIf="isLoggedIn$ | async; else notAuthorized">
	<router-outlet></router-outlet>
</app-layout>
<ng-template #notAuthorized>
	<router-outlet></router-outlet>
</ng-template>-->
<app-layout>
	<router-outlet></router-outlet>
</app-layout>
